import React from 'react'
import { Row, Col } from 'antd'
import styled from 'styled-components'

const BodyWrapper = styled(Row)`
  min-height: 370px;
`

export default function Body({ children }) {
  return (
    <Col span={24}>
      <BodyWrapper justify="center" gutter={[0, 0]}>
        <Col xs={23} sm={20} md={20} lg={22} xl={20} xxl={18}>
          {children}
        </Col>
      </BodyWrapper>
    </Col>
  )
}
